import type { GoogleMapCoordinates } from "@/api/dto/coordinates.dto";

export const USA_MAP_CENTER: GoogleMapCoordinates = { lat: 39.8283, lng: -98.5795 };
